import Instance from "../general.instance";
import {
  ZIP_CODE,
  ZIP_CODE_LOV,
  ZIP_CODE_IMPORT,
  ZIP_CODE_IMPORT_CONFIRM,
  MIDDLE_INSTANCE
} from "../constants";

const MiddleInstance = new Instance(MIDDLE_INSTANCE);

const ZipCodeService = {
  getList(params, token) {
    return MiddleInstance.query(ZIP_CODE, { params, ...token });
  },
  getLov(params) {
    return MiddleInstance.query(ZIP_CODE_LOV, { params });
  },
  getDetail(id) {
    return MiddleInstance.fetch(ZIP_CODE, id);
  },
  create(data) {
    return MiddleInstance.post(ZIP_CODE, data);
  },
  update(data) {
    return MiddleInstance.put(ZIP_CODE, data);
  },
  delete(data) {
    return MiddleInstance.delete(ZIP_CODE, { data });
  },
  import(data) {
    return MiddleInstance.post(ZIP_CODE_IMPORT, data);
  },
  importConfirm(data) {
    return MiddleInstance.post(ZIP_CODE_IMPORT_CONFIRM, data);
  },
  cancelReq() {
    return MiddleInstance.cancelRequest();
  }
};

export default ZipCodeService;
